<eo-dropdown
  [id]="id"
  [label]="label"
  [help]="help"
  [errors]="errors"
  [tabindex]="tabIndex"
  [options]="(httpData$ | async) ?? options ?? []"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [filter]="filter"
  [filterBy]="filterBy"
  [filterFields]="filterFields"
  [filterPlaceholder]="filterPlaceholder"
  [loading]="loading"
  [appendTo]="getAppendTo()"
/>
